<div>
  @if (tenantId) {
    <app-api-job-logs [tenantId]="tenantId"></app-api-job-logs>
  } @else {
    <div class="text-error">
      <p>Unable to load API job logs. Missing required ID.</p>
    </div>
  }
</div>
